export default __webpack_public_path__ + "static/media/loginImage.d1af9b58.svg";